import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, ScrollView, StyleSheet, Text, View } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';
import { get } from 'lodash';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import FilledButton from '../../components/FilledButton';

class ResetPasswordSentScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
  }

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  goNext = () => {
    const { navigation, registration } = this.props;
    const { flow } = registration;
    navigation.navigate('PhoneOrEmail');
  };

  render() {
    const { registration } = this.props;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];
    let email = '';
    if (get(registration, 'emailOrPhoneResult.email')) {
      email = registration.emailOrPhoneResult.email;
    } else if (get(registration, 'enterEmail.results.email')) {
      email = registration.enterEmail.results.email;
    }
    const resetText = translation.reset_password_text.replace('{{email}}', email);

    return (
      <SafeAreaInsetsContext.Consumer>
        {(insets) => (
          <ScrollView
            keyboardShouldPersistTaps="handled"
            contentContainerStyle={styles.mainContentContainer}
            style={[
              styles.container,
              {
                paddingTop: insets.top,
              },
            ]}
            testID="reset-password-sent"
          >
            <Header title={translation.reset_password} goBack={this.goBack} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <Image source={require('../../assets/images/sign_up/image_36.png')} style={styles.image} />
                <Text style={styles.headingText}>{translation.reset_password_sent}</Text>
                <Text style={styles.text}>{resetText}</Text>
              </View>
              <View style={styles.signupFooter}>
                <FilledButton
                  onPress={this.goNext}
                  label={translation.continue}
                  color={Colors.primaryColor}
                  full
                  textColor={Colors.white}
                />
              </View>
            </View>
          </ScrollView>
        )}
      </SafeAreaInsetsContext.Consumer>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    alignItems: 'center',
    paddingBottom: 16,
  },
  headingText: {
    fontSize: Layout.isSmall ? 20 : 26,
    fontWeight: '500',
    color: Colors.veryDarkGray,
    fontFamily: 'roboto-regular',
    textAlign: 'center',
    marginTop: Layout.isSmall ? 53 : 34,
  },
  text: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 14 : 16,
    color: Colors.veryDarkGray,
    textAlign: 'center',
    marginTop: 8,
    width: 328,
  },
  image: {
    height: 101,
    width: 69,
    resizeMode: 'contain',
    marginTop: Layout.isSmall ? 33 : 79,
    marginLeft: -10,
  },
  signupContainer: Layout.signupContainer,
  signupFooter: Layout.signupFooter,
});

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordSentScreen);
